import React, { useEffect } from 'react';

export const useDebouncedEffect = (effect: React.EffectCallback, deps: React.DependencyList, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);
    return () => clearTimeout(handler);
  }, [...(deps || []), delay]);
}